import Vue from "vue";
import RoadMap from "./RoadMap.vue";

export function load() {
  const selector = "RoadMap-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: (createElement) =>
      createElement(RoadMap, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
